import { render, staticRenderFns } from "./DocImplantados.vue?vue&type=template&id=ca870fd0&scoped=true&lang=pug&"
import script from "./DocImplantados.vue?vue&type=script&lang=js&"
export * from "./DocImplantados.vue?vue&type=script&lang=js&"
import style0 from "./DocImplantados.vue?vue&type=style&index=0&id=ca870fd0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca870fd0",
  null
  
)

export default component.exports